/* ──────────────────────────────────────────────────────────────
 *  LengthLimitDialog — Training-data length limit notice
 *
 *  Shown when core/sleeve length is clamped to the training-data
 *  maximum. Reads dynamic content (field name, max value) from
 *  useUIStore.lengthLimitPayload.
 *
 *  Ported from BushingApp.length_limit_dialog (optibush.py).
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const LengthLimitDialog: React.FC = () => {
  const open = useUIStore((s) => s.lengthLimitDialogOpen);
  const { fieldLabel, minValue, maxValue } = useUIStore((s) => s.lengthLimitPayload);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('lengthLimitDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Training Data Limit Notice"
      titleColor="info.main"
      icon={<InfoIcon color="info" sx={{ fontSize: 28 }} />}
      maxWidth={560}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      In the training data, the minimum {fieldLabel} is{' '}
      {minValue.toFixed(2)} mm and the maximum is{' '}
      {maxValue.toFixed(2)} mm. Please patch up in CAD as per requirement.
    </DialogShell>
  );
};

export default LengthLimitDialog;
